var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile',attrs:{"color":"primary","outlined":"","data-cy":'btn_voltar_passo_' + _vm.index},on:{"click":_vm.setAnterior}},[_vm._v("\n  Voltar\n")])}
var staticRenderFns = []

export { render, staticRenderFns }